// loader.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class HeaderService {
    public userDetails = new BehaviorSubject({});
    public profileImageUpdate = new BehaviorSubject({});
    public issueData = new BehaviorSubject({});
    // Emits every time a `live_order` push arrives over the socket (see SocketService.onLiveOrder,
    // wired up in AppComponent). Plain Subject (not BehaviorSubject) — late subscribers should not
    // replay the last order and trigger a spurious refresh on component load.
    public liveOrderData = new Subject<any>();

    constructor() { }
}